import { createContext } from "react";

export const LegalEntityContext = createContext("");
